export default ({ theme }) => `
display: flex;
flex-direction: column;
align-items: center;
width: 100%;

  .button-container {
    display: flex;
    align-items: center;
  }

`;